import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Button, Row, Col, Icon } from 'antd'
import { changeFormatdateSlip } from '../../../../../utils/formatdate'
import moment from 'moment'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { UrlMeeting } from '../../../../../utils/auth'
import axiosAPI from '../../../../../config/axiosAPI'

const { Text, Title } = Typography


class ViewWaitApproveMeeting extends Component {
	state = {
	}

	getNameOrganizer = (id) => {
		axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
			{
				MeetingID: id
			})
			.then(response => {
				const data = response.data.status.message[1].ApproverDetail
				const name = data.title + " " + data.firstName + " " + data.lastName
				// console.log("datadatadatadata", name);
				document.getElementById('nameUser').innerHTML = name;
				return 0;
			}).catch(
				error => console.error(`Error: ${error}`)
			)
	}
	render() {
		const { dataMeeting, changeStatus } = this.props
		const { getFieldDecorator } = this.props.form;
		return (
			<Row gutter={16} >

				{dataMeeting && dataMeeting.length > 0 ?
					dataMeeting.map((MeetingList, i) => {
						return (
							<Col span={24} className={"box-show-meeting p-3 pl-4 my-3"}>
								<Row gutter={16}>
									<Link
										to={{
											pathname: `/meetingmanagement/approveMeetingForm/`,
											search: 'id=' + MeetingList.id,
										}}>
										<Col span={16} className={'py-3'}>
											<Icon className="icon-box-meeting" type="user" style={{ display: "inline" }} />
											<p style={{ display: "inline" }} className={"text-box-meeting"} id="nameUser">
												{MeetingList.firstNameOrganizer} {MeetingList.lastNameOrganizer}
											</p>
										</Col>

										<Col span={7} align="end">
											<Icon type="right" style={{ color: "#666666" }} />
										</Col>
										<Col span={16}>
											<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="sound" />{MeetingList.subject}</p>
										</Col>
										<Col span={7} align="end">
										</Col>
										<Col span={16}>
											<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="clock-circle" />{changeFormatdateSlip(moment(MeetingList.startDate))} / {moment(MeetingList.startDate).format('HH:ss')} - {moment(MeetingList.endDate).format('HH:ss')} น.</p>
										</Col>
										<Col span={7}>

										</Col>
										<Col span={16}>
											<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="environment" />{MeetingList.location}</p>
										</Col>
									</Link>
									{
										MeetingList.isApproved == "0" ?
											<>
												<Col span={4} align="end">
													<Button onClick={() => changeStatus(MeetingList.id, "reject")} className={'button-meeting-not-approve mt-3 mt-lg-0'}>
														ไม่อนุมัติ</Button>
												</Col>
												<Col span={4} align="end">
													<Button onClick={() => changeStatus(MeetingList.id, "approve")} className={'button-meeting-approve mt-3 mt-lg-0'}>
														อนุมัติ</Button>
												</Col>
											</>
											:
											<></>
									}
									{MeetingList.isApproved == 1 ?
										<Col span={7} align="end">
											<p className={"text-box-meeting"} style={{ color: "#178991" }}><Icon className="pr-2" type="check-circle" />อนุมัติ</p>
										</Col>
										:
										<></>
									}
									{MeetingList.isApproved == 2 ?
										<Col span={7} align="end">
											<p className={"text-box-meeting"} style={{ color: "#D94339" }}><Icon className="pr-2" type="close-circle" />ไม่อนุมัติ</p>
										</Col>
										:
										<></>
									}
									{MeetingList.isApproved == 3 ?
										<Col span={7} align="end">
											<p className={"text-box-meeting"} style={{ color: "#178991" }}><Icon className="pr-2" type="check-circle" />ขอแก้ไขและอนุมัติ</p>
										</Col>
										:
										<></>
									}
								</Row>
							</Col>
						)
					})
					:
					<Col xs={24} md={24} align={"center"} style={{ marginTop: "150px" }}>
						<Text>ไม่พบข้อมูล</Text>
					</Col>}
				<Col xs={{ span: 24, offset: 0 }}>
					{/*{dataMeeting}*/}
				</Col>
			</Row>
		)
	}
}


ViewWaitApproveMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(ViewWaitApproveMeeting)

export default withApollo(WrappedAddMeeting)